import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import { TransactionType } from '..'
import type { ScheduledPayment, GlobalErrorHandler } from '..'

export class ScheduledPaymentsApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  addScheduledPayment = async (scheduledPayment: ScheduledPayment) => {
    return this.fetchInstance
      .post(ApiEndpoints.SCHEDULED_PAYMENTS, {
        ...scheduledPayment,
        is_recurring: 'true',
        transaction_type: TransactionType.DEBIT,
      })
      .then((data) => data.scheduled_payment)
  }

  getScheduledPayments = async () => {
    return this.fetchInstance
      .get(ApiEndpoints.SCHEDULED_PAYMENTS)
      .then((data) => data.scheduled_payments)
  }

  updateScheduledPayment = async (scheduledPayment: ScheduledPayment) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.SCHEDULED_PAYMENTS}/${scheduledPayment.guid}`, scheduledPayment)
      .then((data) => data.scheduled_payment)
  }

  deleteScheduledPayment = async (guid: string) => {
    return this.fetchInstance
      .delete(`${ApiEndpoints.SCHEDULED_PAYMENTS}/${guid}`)
      .then((data) => data)
  }
}
